export default __webpack_public_path__ + "static/media/acuadori_header.b8bc76e8.png";